import { Component, Input, OnInit } from "@angular/core"
import { IconImageService } from "@shared/services/icon-image.service"

@Component({
  selector: "ag-avatar",
  standalone: false,
  templateUrl: "./ag-avatar.component.html",
  styleUrl: "./ag-avatar.component.scss",
})
export class AgAvatarComponent implements OnInit {
  @Input() Initials: string[] = [""]
  @Input() AvatarImagePath: string[] = [""]
  @Input() IconImagePath: string[] = [this.iconService.Icon.avatar]
  @Input() Size: Size = "medium"
  @Input() Fallback: FallBack = "Icon"
  @Input() StackedAvatars: boolean = false
  @Input() StackedPluralText: string = ""
  @Input() backgroundColor: string[] = ["#f2f2f2"]

  imagesLoaded: boolean = false
  public imageError: boolean[] = []
  public fourArray: string[] = ["", "", "", ""]
  constructor(public iconService: IconImageService) {}

  ngOnInit(): void {
    this.imagesLoaded = false
    this.processInitials()
    if (this.StackedAvatars && this.AvatarImagePath.length < this.IconImagePath.length) {
      this.fourArray.forEach((icon, index) => {
        if (!this.AvatarImagePath[index]) {
          this.AvatarImagePath[index] = ""
        }
        if (!this.backgroundColor[index]) {
          this.backgroundColor[index] = "#f2f2f2"
        }
      })
    } else if (this.StackedAvatars) {
      this.fourArray.forEach((image, index) => {
        if (!this.IconImagePath[index]) {
          this.IconImagePath[index] = this.iconService.Icon.avatar
        }
        if (!this.backgroundColor[index]) {
          this.backgroundColor[index] = "#f2f2f2"
        }
      })
    }

    const imageChecks = this.AvatarImagePath.map((image, index) => {
      if (index < 5)
        return this.checkImage(image).then((isValid) => {
          if (isValid) {
            this.imageError[index] = false
          } else {
            this.imageError[index] = true
          }
        })
    })

    Promise.all(imageChecks).then(() => {
      this.imagesLoaded = true
    })
  }

  processInitials() {
    this.Initials = this.Initials.map((initial) => {
      if (!initial) return ""

      const words = initial.trim().split(/\s+/)

      if (words.length >= 2) {
        const firstInitial = words[0].charAt(0).toUpperCase()
        const secondInitial = words[1].charAt(0).toUpperCase()
        return firstInitial + secondInitial
      } else {
        const firstInitial = words[0].charAt(0).toUpperCase()
        const secondInitial = words[0].charAt(1)?.toUpperCase() || ""
        return firstInitial + secondInitial
      }
    })
  }

  checkImage(url: string): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image()
      img.onload = () => resolve(true)
      img.onerror = () => resolve(false)
      img.src = url
    })
  }
}

export type Size = "extralarge" | "large" | "medium" | "small"
export type FallBack = "Icon" | "Initials"
